import { render, staticRenderFns } from "./TrySourceDownload.vue?vue&type=template&id=a4a3fa08&scoped=true"
import script from "./TrySourceDownload.vue?vue&type=script&lang=js"
export * from "./TrySourceDownload.vue?vue&type=script&lang=js"
import style0 from "./TrySourceDownload.vue?vue&type=style&index=0&id=a4a3fa08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a3fa08",
  null
  
)

export default component.exports